import { useEffect } from "react";
import { Field, useFormState, useForm } from "react-final-form";
import { useIntl } from "react-intl";
import { DropdownInput, SwitchInput, TextInput } from "../../common/fields";
import Section from "../../common/section";
import { MenuConstants } from "../../../constants";

const LearningSettingsForm = ({ disabled, record }) => {
  const intl = useIntl();
  const formState = useFormState();
  const form = useForm();

  useEffect(() => {
    if (
      !formState.values.showLearningBanner &&
      formState.values.showLearningStats
    ) {
      form.change("showLearningStats", false);
    }
  }, [formState.values.showLearningBanner, form]);

  return (
    <div className="flex flex-column gap-2">
      <Section title="learner_settings">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={SwitchInput}
              type="checkbox"
              name="showLearningBanner"
              label={intl.formatMessage({
                id: "show_learner_banner",
              })}
              disabled={disabled}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={SwitchInput}
              type="checkbox"
              name="showLearningStats"
              label={intl.formatMessage({
                id: "show_learner_stats",
              })}
              disabled={disabled || !formState.values.showLearningBanner}
            />
          </div>
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={SwitchInput}
              type="checkbox"
              name="canCustomiseDashboard"
              label={intl.formatMessage({
                id: "can_customise_dashboard",
              })}
              disabled={disabled}
            />
          </div> */}
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={SwitchInput}
              type="checkbox"
              name="canUpdateSelfProfile"
              label={intl.formatMessage({
                id: "can_update_profile",
              })}
              disabled={disabled}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={DropdownInput}
              name="defaultDashboard"
              label={intl.formatMessage({
                id: "default_dashboard",
              })}
              placeholder={intl.formatMessage({
                id: "default_dashboard",
              })}
              options={MenuConstants.LEARNER_DASHBOARD_TYPES}
              disabled={disabled}
            />
          </div>
        </div>
      </Section>
      <Section title="labels">
        <div className="grid">
          <div className="col-12 md:col-4 lg:4">
            <Field
              component={TextInput}
              name="customLabels.dashboard"
              label={intl.formatMessage({
                id: "dashboard",
              })}
              disabled={disabled}
            />
          </div>
          <div className="col-12 md:col-4 lg:4">
            <Field
              component={TextInput}
              name="customLabels.learningJourney"
              label={intl.formatMessage({
                id: "learning_journey",
              })}
              disabled={disabled}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default LearningSettingsForm;
